<template>
    <div class="container" :class="classes" :style="styles">
        <slot />
    </div>
</template>

<script setup lang="ts">
    interface ContainerProps {
        width?: 'default' | 'small' | 'full' | 'landing' | 'profile' | number
        withoutPadding?: boolean
    }

    const props = withDefaults(defineProps<ContainerProps>(), {
        width: 'default',
        withoutPadding: false,
    })

    const classes = computed(() => ({
        _default: props.width === 'default',
        _small: props.width === 'small',
        _full: props.width === 'full',
        _landing: props.width === 'landing',
        _profile: props.width === 'profile',
        '_without-padding': props.withoutPadding,
    }))

    const styles = computed(() => ({
        maxWidth: typeof props.width === 'number' ? `${props.width}px` : undefined,
    }))
</script>

<style lang="scss" scoped>
    .container {
        width: 100%;
        margin: 0 auto;

        &._default {
            --container-offset: 80px;

            max-width: calc(1280px + 2 * var(--container-offset));
            padding: 0 var(--container-offset);

            @include respond-to(tablet) {
                --container-offset: 32px;
            }

            @include respond-to(mobile) {
                --container-offset: 12px;
            }
        }

        &._full {
            padding: 0;
        }

        &._landing {
            --container-offset: 80px;

            max-width: calc(1280px + 2 * var(--container-offset));
            padding: 0 var(--container-offset);

            @include respond-to(tablet) {
                --container-offset: 32px;
            }

            @include respond-to(mobile) {
                --container-offset: 12px;
            }
        }

        &._profile {
            --container-offset: 80px;

            max-width: calc(1222px + 2 * var(--container-offset));
            padding: 0 var(--container-offset);

            @include respond-to(tablet) {
                --container-offset: 32px;
            }

            @include respond-to(mobile) {
                --container-offset: 0;
            }
        }

        &._without-padding {
            padding: 0;
        }
    }
</style>
